module.exports = __webpack_public_path__ + "assets/images.c91fe935.svg";